import { Route, Routes } from "react-router-dom";
import { lazy } from "react";
import { IUQLayout } from "../components/layouts/IUQLayout";
const DashboardRoute = lazy(() => import("./authenticated/admin/Dashboard"));
const BasicSearch = lazy(() => import("../features/iuq/search/basic"));
const SettingsNotifications = lazy(() => import("../features/settings/notifications"));
const AdvancedSearch = lazy(() => import("../features/iuq/search/advanced"));
const Settings = lazy(() => import("../features/settings"));
const SettingsProfile = lazy(() => import("../features/settings/profile"));
const ChangePassword = lazy(() => import("../features/settings/change-password"));
const SettingsAccount = lazy(() => import("../features/settings/account"));
const SettingsAppearance = lazy(() => import("../features/settings/appearance"));
const AppStats = lazy(() => import("../features/reports/application/stats"));
const ReportAdminError = lazy(() => import("../features/report-admin-error"));
const NotFoundAuthed = lazy(() => import("./authenticated/admin/NotFound"));
const AdvancedSearchRegrettedApplicants = lazy(() => import("@/features/iuq/search/advanced/regretted-appliants"));
const BasicSearchPersonal = lazy(() => import("@/features/iuq/search/basic/personal/personal-form"));
const BasicSearchCAO = lazy(() => import("@/features/iuq/search/basic/cao/cao-form"));
const WebWalkInsSearch = lazy(() => import("@/features/iuq/search/web-walk-ins"));
const WebWalkInsCaoSearch = lazy(() => import("@/features/iuq/search/web-walk-ins/cao/cao-form"));
const WebWalkInsPersonalSearch = lazy(() => import("@/features/iuq/search/web-walk-ins/personal/personal-form"));
const BasicSearchQualificationForm = lazy(() => import("@/features/iuq/search/basic/qualification/qualification-form"));
const AdvancedSearchAcademic = lazy(() => import("@/features/iuq/search/advanced/academic"));
const SearchByGeneralCriteria = lazy(() => import("@/features/iuq/search/advanced/general/general-search-form"));
const AdvancedProgrammeChoiceForm = lazy(() => import("@/features/iuq/search/advanced/programme-choice/programme-choice-form"));
const DemographicSearchForm = lazy(() => import("@/features/iuq/search/advanced/demographic/demographic-search-form"));
const ClearingHouse = lazy(() => import("@/features/iuq/clearing-house"));
const ClearingHouseProgrammeForm = lazy(() => import("@/features/iuq/clearing-house/search/programme/programme-form"));
const ClearingHouseAcademicForm = lazy(() => import("@/features/iuq/clearing-house/search/academic/academic-form"));
const CheckResults = lazy(() => import("@/features/iuq/check-results"));
const WalkInMaintenance = lazy(() => import("@/features/iuq/maintenance/walk-in"));
const IUQDownloads = lazy(() => import("@/features/iuq/processing/downloads"));
const ApplicantTotalsReport = lazy(() => import("@/features/admin/reports/applicant-totals"));
const ApplicantGeographicStatisticsReport = lazy(() => import("@/features/admin/reports/applicant-geographic-statistics"));
const ApplicantsPerQualificationReport = lazy(() => import("@/features/admin/reports/applicants-per-qualification"));
const ApplicantGenderPopAgeReport = lazy(() => import("@/features/admin/reports/applicant-gender-pop-age"));
const ApplicantGenderPopLangReport = lazy(() => import("@/features/admin/reports/applicant-gender-pop-lang"));
const InstitutionsStatisticsReport = lazy(() => import("@/features/admin/reports/institutions-statistics"));
const ApplicantStatisticsPerInstitutionReport = lazy(() => import("@/features/admin/reports/applicant-statistics-per-institution"));
const SchoolStatisticsReport = lazy(() => import("@/features/admin/reports/school-statistics"));
const ApplicantSummaryReport = lazy(() => import("@/features/admin/reports/applicant-summary"));
const ApplicationListingReport = lazy(() => import("@/features/admin/reports/application-listing"));
const ApplicationStatisticsReport = lazy(() => import("@/features/admin/reports/application-statistics"));

export const IUQRoutes = () => {
  return (
    <Routes>
      <Route element={<IUQLayout />}>
        <Route index element={<DashboardRoute />} />
        <Route path="search/basic" element={<BasicSearch />}>
          <Route path="cao" element={<BasicSearchCAO />} />
          <Route path="personal" element={<BasicSearchPersonal />} />
          <Route
            path="qualification"
            element={<BasicSearchQualificationForm />}
          />
        </Route>
        <Route path="search/advanced" element={<AdvancedSearch />}>
          <Route path="academic" element={<AdvancedSearchAcademic />} />
          <Route path="general" element={<SearchByGeneralCriteria />} />
          <Route
            path="programme-choice"
            element={<AdvancedProgrammeChoiceForm />}
          />
          <Route path="demographic" element={<DemographicSearchForm />} />

          <Route
            path="regretted-applicants"
            element={<AdvancedSearchRegrettedApplicants />}
          />
          <Route
            path="regretted-applicants-ranking"
            element={<AdvancedSearchRegrettedApplicants />}
          />
        </Route>
        <Route path="search/web-walk-ins" element={<WebWalkInsSearch />}>
          <Route path="cao" element={<WebWalkInsCaoSearch />} />
          <Route path="personal" element={<WebWalkInsPersonalSearch />} />
        </Route>

        <Route path="clearing-house" element={<ClearingHouse />}>
          <Route
            path="search/programme"
            element={<ClearingHouseProgrammeForm />}
          />
          <Route
            path="search/academic"
            element={<ClearingHouseAcademicForm />}
          />
        </Route>

        <Route path="reports">
          <Route path="check-results" element={<CheckResults />} />
          <Route path="application/application-stats" element={<AppStats />} />
          <Route path="applicant-totals" element={<ApplicantTotalsReport />} />
          <Route path="application-per-qualification" element={<ApplicantsPerQualificationReport />} />
          <Route path="applicant-geographic-statistics" element={<ApplicantGeographicStatisticsReport />} />
          <Route path="applicants-statistics/gender-pop-age" element={<ApplicantGenderPopAgeReport />} />
          <Route path="applicants-statistics/gender-pop-lang" element={<ApplicantGenderPopLangReport />} />
          <Route path="institutions-statistics" element={<InstitutionsStatisticsReport />} />
          <Route path="applicant-statistics-per-institution" element={<ApplicantStatisticsPerInstitutionReport />} />
          <Route path="school-statistics" element={<SchoolStatisticsReport />} />
          <Route path="applicant-summary" element={<ApplicantSummaryReport />} />
          <Route path="application-listing" element={<ApplicationListingReport />} />
          <Route path="application-statistics" element={<ApplicationStatisticsReport />} />
        </Route>

        <Route path="processing">
          <Route path="downloads" element={<IUQDownloads />} />
        </Route>

        <Route path="settings" element={<Settings />}>
          <Route index element={<SettingsProfile />} />
          <Route path="change-password" element={<ChangePassword />} />
          <Route path="account" element={<SettingsAccount />} />
          <Route path="appearance" element={<SettingsAppearance />} />
          <Route path="notifications" element={<SettingsNotifications />} />
        </Route>

        <Route path="maintenance/walk-in" element={<WalkInMaintenance />} />
        <Route path="report-admin-error" element={<ReportAdminError />} />
        <Route path="*" element={<NotFoundAuthed />} />
      </Route>
    </Routes>
  );
};
